import { render, staticRenderFns } from "./DetailsPhone.vue?vue&type=template&id=3e22bf0a&"
import script from "./DetailsPhone.vue?vue&type=script&lang=js&"
export * from "./DetailsPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports